import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';

const SidebarItem = ({ item, isHovered, isActive, onHover, onClick }) => {
  return (
    <li
      className={`sidebar-item ${isActive ? 'active' : ''}`}
      onMouseEnter={() => onHover(item.name)}
      onMouseLeave={() => onHover(null)}
      onClick={onClick}
    >
      <Link to={item.to} className="item-content">
        <Icon icon={item.icon} className="icon"  style={{fontSize:'28px'}}/>
        <span className="item-name">{item.name}</span>
        {item.notifications > 0 && (
          <span className="badge">{item.notifications}</span>
        )}
      </Link>
      {isHovered && item.submenu && (
        <ul className="submenu">
          {item.submenu.map((subitem) => (
            <li key={subitem.name} className="submenu-item">
              <Link to={subitem.to} className="submenu-item-content">
                <span className="item-name">{subitem.name}</span>
              </Link>
              {isHovered && subitem.submenu && (
                <ul className="subsubmenu">
                  {subitem.submenu.map((subsubitem) => (
                    <li key={subsubitem.name} className="subsubmenu-item">
                      <Link to={subsubitem.to}>
                        {subsubitem.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SidebarItem;
